import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAll(filters: any) {
  let queryParams: string[] = [];

  if (filters) {
    if (filters.init_date) {
      queryParams.push(`init_date=${filters.init_date}`);
    }
    if (filters.end_date) {
      queryParams.push(`end_date=${filters.end_date}`);
    }
    if (filters.search) {
      queryParams.push(`search=${encodeURIComponent(filters.search)}`);
    }
  }

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  const response = await axios.get(`${API_URL}catalogos/activation${queryString}`);
  const data = response.data.doc.data;
  return data;
}

// CAMBIO DE LOS CAROS
export async function getOffers(filter: string) {
  if (filter === 'activation_ho' || filter === 'recharge_ho' || filter === 'activation_hogar' || filter === 'recharge_hogar') {
    const typeUrl = (filter === 'activation_ho' || filter === 'activation_hogar') ? 'activation_hogar' : 'recharge_hogar';
    const response = await axios.get(`${API_URL}operation/offers/saldo/${typeUrl}`);
    let data = [];
    if (Array.isArray(response.data.doc?.data)) {
      data = response.data.doc.data;
    } else if (response.data.doc?.data?.rows) {
      data = response.data.doc.data.rows;
    }
    return data;
  }

  let queryParams = 'type_id=19&service_type=TELEFONIA'; // default to telefonia activacion

  
  if (filter === 'activation_mifi') {
    queryParams = 'type_id=19&service_type=MIFI';
  } else if (filter === 'recharge_mifi') {
    queryParams = 'type_id=18&service_type=MIFI';
  } else if (filter === 'recharge') {
    queryParams = 'type_id=18&service_type=TELEFONIA';
  } else if (filter === 'activation_ho') {
    queryParams = 'type_id=19&service_type=HO';
  } else if (filter === 'recharge_ho') {
    queryParams = 'type_id=18&service_type=HO';
  }

  const response = await axios.get(
    `${API_URL}catalogos/offer?${queryParams}`
  );
  let data = [];
  if (Array.isArray(response.data.doc?.data)) {
    data = response.data.doc.data;
  } else if (response.data.doc?.data?.rows) {
    data = response.data.doc.data.rows;
  }
  
  const uniqueOffers: any[] = [];
  const seen = new Set();

  for (const r of data) {
    const key = `${r.commercial_name}_${r.price}`;
    if (!seen.has(key)) {
      seen.add(key);
      uniqueOffers.push(r);
    }
  }

  return uniqueOffers;
}

export async function getSelectCodes() {
  const response = await axios.get(`${API_URL}reports/codes`);
  const data = response.data.doc.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = row.code;
    row.value = row.code;
  });
  return dataSelect;
}

export async function createActivation(body: any) {
  const {
    iccid,
    offer_id,
    schedule_date,
    email,
    first_name,
    mother_last_name,
    father_last_name,
    birthdate,
    gender_id,
    inmediality,
    imei,
    product_type = 'telefonia',
    address,
  } = body;
  
  let dateActivation = null;
  if (schedule_date) {
    dateActivation = new Date(schedule_date).toISOString().split('T')[0];
  }
  
  const payload: any = {
    iccid: iccid,
    offer_id: Number(offer_id),
    schedule_date: Number(inmediality) === 1 ? null : dateActivation,
    correo: email,
    nombre: first_name,
    apellido_paterno: father_last_name,
    apellido_materno: mother_last_name,
    isPortability: false,
    product_type: product_type,
    address: address,
  };
  
  if (birthdate) payload.fecha_nacimiento = new Date(birthdate).toISOString().split('T')[0];
  if (gender_id) payload.gender_id = Number(gender_id);
  if (imei) payload.imei = imei;

  const response = await axios.post(`${API_URL}operation/activation/`, payload);
  return response;
}


export async function createMobileActivation(body: any) {
  const { iccid, address, product_type } = body;
  const response = await axios.post(`${API_URL}operation/activation/mobile`, {
    iccid,
    address,
    product_type: product_type || 'hogar',
  });
  return response;
}

export async function getSelectUser() {
  const response = await axios.get(`${API_URL}reports/users`);
  const data = response.data.data;
  let dataSelect: any = data;
  dataSelect.forEach((row: any) => {
    row.label = row.name;
    row.value = row.id;
  });
  return dataSelect;
}
